import { Portals } from '../interfaces';

export const mockPortals: Portals = {
  APPS: {
    id: 'APPS',
    shortName: 'APPS',
    name: 'APP_SWITCHER.APPS.NAME',
    message: '',
    hiddenInAppSwitcher: true,
  },
  ONLINE: {
    id: 'ONLINE',
    name: 'APP_SWITCHER.ONLINE.NAME',
    message: 'APP_SWITCHER.ONLINE.MESSAGE',
    shortName: 'RSCOM',
  },
  NA: {
    id: 'NA',
    name: 'APP_SWITCHER.NA.NAME',
    message: 'APP_SWITCHER.NA.MESSAGE',
    shortName: 'NA',
  },
  SW: {
    id: 'SW',
    name: 'APP_SWITCHER.SW.NAME',
    message: 'APP_SWITCHER.SW.MESSAGE',
    shortName: 'SW',
  },
  COR1: {
    id: 'COR1',
    name: 'APP_SWITCHER.COR1.NAME',
    message: 'APP_SWITCHER.COR1.MESSAGE',
    pendingStateMessage: 'APP_SWITCHER.PENDING_STATE_MESSAGE',
    deniedStateMessage: 'APP_SWITCHER.DENIED_STATE_MESSAGE',
    shortName: 'COR1',
    link: '',
  },
  COR2: {
    id: 'COR2',
    name: 'APP_SWITCHER.COR2.NAME',
    message: 'APP_SWITCHER.COR2.MESSAGE',
    pendingStateMessage: 'APP_SWITCHER.PENDING_STATE_MESSAGE',
    deniedStateMessage: 'APP_SWITCHER.DENIED_STATE_MESSAGE',
    shortName: 'COR2',
    link: '',
  },
  PROFILE: {
    id: 'PROFILE',
    shortName: 'PROFILE',
    name: 'APP_SWITCHER.PROFILE.NAME',
    message: '',
    hiddenInAppSwitcher: true,
  },
};
